module.exports = __webpack_public_path__ + "static/media/az_logo_all.766641ab.png";